import { memo } from "react"

import type { HelpCenterArticleVersion } from "@productlane/zero"
import { NucleoFillIcon } from "@productlane/ui"

import type { VersionAuthorUser } from "@/components/version-author"
import { VersionHistoryDialog as VersionHistoryDialogBase } from "@/components/version-history/version-history-dialog"
import { ArticlePreview } from "./article-preview"

export type ArticleVersionRow = HelpCenterArticleVersion & {
	createdBy?: VersionAuthorUser | null
}

interface VersionHistoryDialogProps {
	isOpen: boolean
	onOpenChange: (open: boolean) => void
	onRestore: (version: ArticleVersionRow) => void
	versions: readonly ArticleVersionRow[]
	isLoading?: boolean
	articleTitle: string
	articleIcon: string
}

export const VersionHistoryDialog = memo(
	({
		isOpen,
		onOpenChange,
		onRestore,
		versions,
		isLoading,
		articleTitle,
		articleIcon,
	}: VersionHistoryDialogProps) => (
		<VersionHistoryDialogBase
			isOpen={isOpen}
			onOpenChange={onOpenChange}
			versions={versions}
			isLoading={isLoading}
			entityName={
				<span className="flex min-w-0 items-center gap-1.5">
					<NucleoFillIcon icon={articleIcon} className="h-4 w-4 shrink-0" />
					<span className="truncate">{articleTitle || "New document"}</span>
				</span>
			}
			emptyText="Versions appear here as you save changes to this article."
			renderPreview={(version) => (
				<ArticlePreview version={version} key={version.id} />
			)}
			onRestore={onRestore}
		/>
	),
)

VersionHistoryDialog.displayName = "VersionHistoryDialog"
